import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  StatCard,
  ContentCard,
  DashboardHeader,
  Icons,
} from "../common/DashboardComponents";
import StatusBadge from "../common/StatusBadge";

import "bootstrap-icons/font/bootstrap-icons.css";
import {
  fetchGrantEscalationMatrix,
} from "../../redux/actions/grievanceActions1";

const EscalatedGrants = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();


  const [data, setData] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const [grantsPerPage, setGrantsPerPage] = useState(10);

  useEffect(() => {
    const fetchMetrices = async () => {
      try {
        const storedUser = localStorage.getItem("user");
        const role = JSON.parse(storedUser);
        const response = await dispatch(fetchGrantEscalationMatrix(role?.role));
        console.log(response, "response");
        if (response) {
          setData(response);
        }
        console.log("matrix details:", response);
      } catch (error) {
        console.error("Error fetching contact:", error);
      }
    };

    fetchMetrices();
  }, [dispatch]);

  const countGrantsByStatus = (statusIds) => {
    return data.filter((g) => statusIds.includes(g.STATUS_ID)).length;
  };

  const totalGrants = data.length;
  const pendingGrants = countGrantsByStatus(["10", "11", "13", "14", "15"]);
  const approvedGrants = countGrantsByStatus(["16"]);
  const rejectedGrants = countGrantsByStatus(["12", "17"]);

  // Get current grants for pagination
  const indexOfLastGrant = currentPage * grantsPerPage;
  const indexOfFirstGrant = indexOfLastGrant - grantsPerPage;
  const currentGrants = data.slice(indexOfFirstGrant, indexOfLastGrant);

  const totalPages = Math.ceil(data.length / grantsPerPage);

  // Change page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Go to next page
  const nextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  // Go to previous page
  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  return (
    <div className="container-fluid">
      <DashboardHeader title="Escalated Grants" />

      <div className="stats-grid">
        <StatCard
          title="Total Grants"
          value={totalGrants}
          icon={Icons.Grants}
          color="#4CAF50"
          additionalInfo={
            <>
              <span className="me-2">Pending: {pendingGrants}</span>
              <span className="me-2">Approved: {approvedGrants}</span>
              <span>Rejected: {rejectedGrants}</span>
            </>
          }
        />
      </div>

      <ContentCard title="Grant List" icon={Icons.Grants}>

        <>
          <div className="table-responsive">
            <table className="table border-top border-bottom">
              <thead className="bg-light">
                <tr>
                  <th className="py-3">ID</th>
                  {/* <th className="py-3">Remarks</th> */}
                  <th className="py-3">Scheme</th>
                  <th className="py-3">Amount</th>

                  <th className="py-3">Submission Date</th>
                  <th className="py-3">ARESA Center</th>
                  <th className="py-3">Status</th>
                  <th className="py-3">Actions</th>
                </tr>
              </thead>
              <tbody>
                {currentGrants.length === 0 ? (
                  <tr>
                    <td colSpan="7" className="text-center py-4">
                      No grants found
                    </td>
                  </tr>
                ) : (
                  currentGrants.map((grant, index) => (
                    <tr
                      key={`grant_${grant.APP_ID}_${index}`}
                      className="border-bottom"
                    >
                      <td className="py-2">{grant.APP_ID}</td>
                      {/* <td className="py-2">{grant.LAST_STATUS_REMARKS || "N/A"}</td> */}
                      <td className="py-2">{grant.GRANT_TYPE}</td>
                      <td className="py-2">
                        ₹{(grant.PENSION_AMOUNT || "0").toLocaleString()}
                      </td>
                      <td className="py-2">
                        {grant.ENTRY_DATETIME || "N/A"}
                      </td>

                      <td className="py-2">{grant.UNIT_CENTRE_NAME}</td>
                      <td className="py-2">
                        <StatusBadge
                          status={grant.STATUS_NAME}
                          isGrant={true}
                        />
                      </td>
                      <td>
                        <button
                          onClick={() => {
                            navigate(`/EscalatedGrantsDetails`, {
                              state: {
                                id: grant.APP_ID,
                                esm: grant.ESM_ID || "N/A",
                                centerName: grant.UNIT_CENTRE_NAME || "N/A",
                                grnatDetails: grant,
                              },
                            });
                          }}
                          className="btn btn-sm btn-primary rounded-pill px-3"
                        >
                          <i className="bi bi-eye-fill me-1"></i> View
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          {data.length > 0 && (
            <div className="d-flex justify-content-end mt-3">
              <nav aria-label="Grant pagination">
                <ul className="pagination mb-0">
                  <li
                    className={`page-item ${currentPage === 1 ? "disabled" : ""
                      }`}
                  >
                    <button
                      onClick={() => paginate(1)}
                      className="page-link border"
                      aria-label="First"
                    >
                      <span aria-hidden="true">&laquo;&laquo;</span>
                    </button>
                  </li>
                  <li
                    className={`page-item ${currentPage === 1 ? "disabled" : ""
                      }`}
                  >
                    <button
                      onClick={prevPage}
                      className="page-link border"
                      aria-label="Previous"
                    >
                      <span aria-hidden="true">&laquo;</span>
                    </button>
                  </li>

                  <li className="page-item active mx-2">
                    <button
                      className="page-link rounded-circle"
                      style={{ width: "36px", height: "36px" }}
                    >
                      {currentPage}
                    </button>
                  </li>

                  <li
                    className={`page-item ${currentPage === totalPages ? "disabled" : ""
                      }`}
                  >
                    <button
                      onClick={nextPage}
                      className="page-link border"
                      aria-label="Next"
                    >
                      <span aria-hidden="true">&raquo;</span>
                    </button>
                  </li>
                  <li
                    className={`page-item ${currentPage === totalPages ? "disabled" : ""
                      }`}
                  >
                    <button
                      onClick={() => paginate(totalPages)}
                      className="page-link border"
                      aria-label="Last"
                    >
                      <span aria-hidden="true">&raquo;&raquo;</span>
                    </button>
                  </li>
                </ul>
              </nav>
            </div>
          )}
        </>

      </ContentCard>
    </div>
  );
};

export default EscalatedGrants;
